export const errors = {
  updateContentRating: "Failed to update content rating. Please try again.",
  deleteSubmission: "Failed to delete submission. Please try again.",
  updateApprovalStatus: "Failed to update approval status. Please try again.",
  deleteResponse: "Failed to delete response. Please try again.",
  saveSubscriber: "Error saving subscriber",
  removeSubscriber: "Error removing subscriber",
  checkDuplicates: "Error checking duplicates",
  importSubscribers: "Error importing subscribers",
  exportSubscribers: "Error exporting subscribers",
  bulkUpdateSubscribers: "Error updating subscribers",
  bulkRemoveSubscribers: "Error removing subscribers",
  noValidEmails: "No valid emails found",
  selectSubscribersToEdit: "Please select subscribers to edit",
  selectSubscribersToDelete: "Please select subscribers to delete",
  loadFileContentFailed: "Failed to load file content",
  fileTypeCannotBePreviewed: "This file type cannot be previewed",
  saveFailed: "Failed to save. Please try again.",
  loadFailed: "Failed to load. Please try again.",
  transcriptionNoAudioFile:
    "This recording has no stored audio file path, so transcription cannot be started. Re-upload the audio or save the recording again.",
  transcriptionInitFailed: "Could not start transcription. Please try again.",
  transcriptionDemoMode: "Transcription is not available in demo mode.",
  livingWageLoadFailed: "Failed to load paid work hours",
  livingWageSuggestFailed: "Failed to suggest paid work job",
  livingWageNewTaskFailed: "Failed to suggest new paid work task",
  livingWageInvalidTaskTitle: "Enter a task title",
  livingWageInvalidWorkStream: "Choose or name the work stream this task belongs to",
  livingWageReviewFailed: "Failed to update paid work approval",
  livingWageCancelFailed: "Failed to cancel paid work reservation",
  livingWageCompleteFailed: "Failed to complete paid work reservation",
  livingWageInviteFailed: "Failed to invite paid work collaborator",
  livingWagePartnerAcceptFailed: "Failed to accept paid work partnership",
  livingWagePartnerDeclineFailed: "Failed to decline paid work partnership",
  livingWagePartnerEmailFailed: "Partner invited, but the email could not be sent",
  livingWageInsufficientHours: "Not enough hours left in the paid work pool",
  livingWageInvalidHours: "Enter a valid number of hours",
  livingWagePoolUpdateFailed: "Failed to update monthly pooled hours",
  teamUpdatesLoadFailed: "Failed to load team updates",
  teamUpdatesSaveGroupFailed: "Failed to save team update group",
  teamUpdatesPostFailed: "Failed to post",
  teamUpdatesReplyFailed: "Failed to send reply",
  teamUpdatesVoteFailed: "Failed to save your vote",
  teamUpdatesRequestFailed: "Failed to update this request",
  workStreamTaskRequestFailed: "Failed to send the task request",
  workStreamTaskRequestNoGroup: "Choose a team chat that includes this person",
  teamUpdatesReactionFailed: "Failed to update reaction",
  teamUpdatesUpdateFailed: "Failed to update message",
  teamUpdatesDeleteFailed: "Failed to delete message",
  teamUpdatesDeleteGroupFailed: "Failed to delete this chat",
  teamUpdatesLeaveFailed: "Failed to leave the group",
  teamUpdatesLoadMembersFailed: "Failed to load group members",
  teamUpdatesUpdateMembersFailed: "Failed to update group members",
  teamUpdatesLastMember: "A group must keep at least one member",
  teamUpdatesCallFailed: "Failed to start or join the call",
  teamUpdatesCallLeaveFailed: "Failed to leave the call",
  todoSaveFailed: "Failed to save to-do",
  todoUpdateFailed: "Failed to update to-do",
  todoDeleteFailed: "Failed to delete to-do",
  earningsMonthStatusSaveFailed: "Failed to update invoiced or paid status",
  todoLivingWageNeedsApproval:
    "This paid work job is still pending approval, so it can’t be marked complete yet",
  workStreamProjectRenameFailed: "Failed to rename project on work streams",
  meetingActionAddTaskFailed: "Failed to add action as a work stream task",
  meetingActionsPostFailed: "Failed to post action points to team chat",
  meetingAttendanceSaveFailed: "Failed to update confirmed attendance",
  meetingSettleNeedsAttendees:
    "Add at least one platform admin attendee before settling meeting hours",
  meetingUnsettleFailed: "Failed to unsettle meeting accruals",
  meetingSaveFailed: "Failed to save meeting",
  budgetTrackerLoadFailed: "Failed to load budget trackers",
  budgetTrackerSaveFailed: "Failed to save budget tracker",
  budgetTrackerDeleteFailed: "Failed to delete budget tracker",
  budgetTrackerNameRequired: "Enter a name for the budget tracker",
  budgetTrackerNameExists: "A budget tracker with this name already exists",
  budgetTrackerExpenseInvalid: "Enter a description, people count, and cost per person",
  budgetTrackerCsvImportFailed: "Failed to import CSV",
  budgetTrackerProjectStreamSyncFailed:
    "Tracker saved, but work stream project names could not be updated",
  workstreamTimelineLoadFailed: "Failed to load project workstream timelines",
  workstreamTimelineSaveFailed: "Failed to save project workstream timeline",
  workstreamTimelineCreateFailed: "Failed to create project workstream timeline",
  workstreamTimelineDeleteFailed: "Failed to delete project workstream timeline",
  workstreamTimelineShareFailed: "Failed to update sharing",
  workstreamTimelineImportFailed: "JSON must include strands[] and sections[]",
  workstreamTimelineParseFailed: "Could not parse JSON",
  workstreamTimelineCopyFailed: "Failed to copy link",
  workstreamTimelineTitleRequired: "Enter a title for the timeline",
  workstreamTimelineProjectRequired: "Choose a project for this timeline",
  workstreamTimelineProjectTaken: "That project already has a workstream timeline",
  workstreamTimelinePublicLinkFailed: "Failed to update the public view link",
  meetingCalendarSyncFailed: "Could not add this meeting to the Overhear calendar. Please try again.",
  meetingCalendarNotConfigured:
    "The Overhear Google Calendar is not set up yet. Enable the Calendar API and share the calendar with the Cloud Functions service account.",
  meetingCalendarNotFound: "That meeting could not be found.",
  meetingCalendarNoDate: "This meeting has no scheduled date.",
  meetingCalendarDenied: "You do not have permission to add events to the Overhear calendar.",
}
